// Defines the endpoint environment that will be used for each api (indicators, metrics, layers)
export const indicatorsEnv = import.meta.env.VITE_INDICATORS_ENVIRONMENT;
export const metricsEnv = import.meta.env.VITE_METRICS_ENVIRONMENT;
export const layersEnv = import.meta.env.VITE_LAYERS_ENVIRONMENT;